import { render, staticRenderFns } from "./CorpDashboardWrapper.vue?vue&type=template&id=3a7db882&"
import script from "./CorpDashboardWrapper.vue?vue&type=script&lang=ts&"
export * from "./CorpDashboardWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports